import { useRefresh } from "lib/@hooks/useRefresh"
import { Bound } from "lib/@components/binding/Bound"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { Box } from "@mui/material"
import { Delayed } from "lib/@components/delayed"
import { ErrorPage } from "./error-page"

export function LoadingTemplate({ loading, error, errorHeader, target, children, ...props }) {
    const refresh = useRefresh()

    return (
        <Bound {...props} target={target} masterRefresh={refresh} refresh={refresh}>
            {loading ? (
                <LoadingScreen description="Loading Template" />
            ) : error ? (
                <Box pr={2}>
                    <ErrorPage errorHeader={errorHeader} error={error?.toString()} />
                </Box>
            ) : target ? (
                children
            ) : (
                <Delayed>
                    <Box pr={2}>
                        <ErrorPage />
                    </Box>
                </Delayed>
            )}
        </Bound>
    )
}
